import type { UIMessage } from 'ai';

// Stamp `metadata.aborted = true` on the last assistant message so a client-side
// save on the abort path can't clobber the resumability flag the server persists
// on its own (authoritative) save of the same chat row. Returns the list
// unchanged if there's no assistant message to stamp.
export function withAbortedMetadata(messages: UIMessage[]): UIMessage[] {
  const lastAssistantIndex = messages.map((message) => message.role).lastIndexOf('assistant');

  if (lastAssistantIndex === -1) {
    return messages;
  }

  const lastAssistant = messages[lastAssistantIndex];
  const stamped = { ...lastAssistant, metadata: { ...(lastAssistant.metadata as any), aborted: true } };

  const next = messages.slice();
  next[lastAssistantIndex] = stamped;

  return next;
}
